import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ErrorHandler, inject, NgModule, provideAppInitializer } from "@angular/core";
import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  BlobService as CommonBlobService,
  LoggingService as CommonLoggingService,
  SvgIconService as CommonSvgIconService,
  ConfigService,
  ErrorHandlerService,
  MerriCommonModule,
} from "@merri/common";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppConfigService, BlobService, LoggingService, SvgIconService } from "./core";
import { httpInterceptorProviders } from "./core/interceptors/providers";
import { AssistantModule } from "./features/assistant/assistant.module";
import { FeaturesModule } from "./features/features.module";
import { TutorialsModule } from "./features/tutorials/tutorials.module";
import { LayoutModule } from "./layout/layout.module";
import { ProtectedModule } from "./protected/protected.module";
import { PublicModule } from "./public/public.module";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    LayoutModule,
    PublicModule,
    ProtectedModule,
    FeaturesModule,
    AppRoutingModule,
    TutorialsModule,
    HammerModule,
    AssistantModule,
    MerriCommonModule,
  ],
  providers: [
    { provide: ErrorHandler, useExisting: ErrorHandlerService },
    { provide: ConfigService, useExisting: AppConfigService },
    { provide: CommonBlobService, useExisting: BlobService },
    { provide: CommonSvgIconService, useExisting: SvgIconService },
    { provide: CommonLoggingService, useExisting: LoggingService },
    httpInterceptorProviders,
    provideAppInitializer(() => {
      const initializerFn = ((appConfigService: AppConfigService) => {
        return () => {
          LoggingService.log(JSON.stringify(environment), appConfigService.sessionId);
          return firstValueFrom(appConfigService.loadConfig());
        };
      })(inject(AppConfigService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
